// extracted by mini-css-extract-plugin
module.exports = {"legalDocContainer":"LegalDocuments_legalDocContainer__Rwna6","legalDocTitle":"LegalDocuments_legalDocTitle__S5HXk"};